import { SingleSkeletonLoader } from 'pricing-pages-ui-components/loading/SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BANNER_SKELETON_HEIGHT = 80;
export const PublicBannerSkeleton = ({
  isLoading = true,
  children
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: BANNER_SKELETON_HEIGHT,
      "data-test-id": "public-banner-skeleton",
      marginStyle: {
        marginBlockEnd: '500'
      }
    });
  }
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};